import { useContext } from "react";
import React from "react";
import { Dropdown, Input, Table, Grid, Segment, Select, Form } from "semantic-ui-react";
import { Action, store } from "../store";
import { NamesAndLocationsProps, QAPropsBase } from "../State";
import EnumeratedTable from "../components/EnumeratedTable";

// tslint:disable-next-line: max-line-length
function handleNameLocationChange(value: string, index: number, pos: number, dispatch: React.Dispatch<Action>, s: NamesAndLocationsProps[], type: number): void {
    const newOwnershipState = s.map((v, i) => {
        if (pos === i) {
            switch (type) {
                case 0:
                    return {
                        ...v, name: value
                    }
                case 1:
                    return {
                        ...v, street: value
                    }
                case 2:
                    return {
                        ...v, city: value
                    }
                case 3:
                    return {
                        ...v, state: value
                    }
                case 4:
                    return {
                        ...v, zip: value
                    }
                default:
                    return {
                        ...v
                    }
            }
        } else {
            return { ...v };
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: index });
}


// tslint:disable-next-line: interface-name
interface Props {
    min?: number;
    max?: number;
    index: number;
    propsBase: QAPropsBase;
}

const NamesAndLocationsAnswer: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const namesAndLocations = props.propsBase.answerValue as NamesAndLocationsProps[];
    const nameLocGenerator = () => {
        return {
            name: "", street: "", state: "", city: "", zip: ""
        }
    };

    return (
        <div>
            <EnumeratedTable index={props.index}
                action={{ type: "handle answer update" }}
                generator={nameLocGenerator}
                inverted={globalState.state.appState.isDarkTheme}
                questionContent={"HOW MANY EMPLOYER NAMES/LOCATIONS?"}
                source={namesAndLocations}
                min={props.min} max={props.max}>
                {
                    namesAndLocations.map((o, i, a) =>
                        <Table.Row key={i}>
                            <Table.Cell>
                                <Grid columns={2} stackable style={{maxWidth: "400px"}}>
                                    <Grid.Row  >
                                        <Grid.Column width={8}>
                                            <Form.Input size={"small"} type={"text"} value={o.name} placeholder={"Name"} fluid
                                                    // tslint:disable-next-line: max-line-length
                                                    onChange={(e) => handleNameLocationChange(e.target.value, props.index, i, dispatch, a, 0)} />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Form.Input size={"small"} type={"text"} value={o.street} placeholder={"Street"}
                                                    fluid
                                                // tslint:disable-next-line: max-line-length 
                                                    onChange={(e) => handleNameLocationChange(e.target.value, props.index, i, dispatch, a, 1)} />
                                            <Form.Input size={"small"} type={"text"} value={o.city} placeholder={"City"}
                                                    fluid
                                                    // tslint:disable-next-line: max-line-length
                                                    onChange={(e) => handleNameLocationChange(e.target.value, props.index, i, dispatch, a, 2)} />
                                                <Form.Select size={"small"} type={"text"} value={o.state} placeholder={"State"}
                                                    fluid
                                                    options={[
                                                        { key: "AL", text: "AL", value: "AL" },
                                                        { key: "AK", text: "AK", value: "AK" },
                                                        { key: "AS", text: "AS", value: "AS" },
                                                        { key: "AZ", text: "AZ", value: "AZ" },
                                                        { key: "AR", text: "AR", value: "AR" },
                                                        { key: "CA", text: "CA", value: "CA" },
                                                        { key: "CO", text: "CO", value: "CO" },
                                                        { key: "CT", text: "CT", value: "CT" },
                                                        { key: "DE", text: "DE", value: "DE" },
                                                        { key: "DC", text: "DC", value: "DC" },
                                                        { key: "FL", text: "FL", value: "FL" },
                                                        { key: "GA", text: "GA", value: "GA" },
                                                        { key: "HI", text: "HI", value: "HI" },
                                                        { key: "ID", text: "ID", value: "ID" },
                                                        { key: "IL", text: "IL", value: "IL" },
                                                        { key: "IN", text: "IN", value: "IN" },
                                                        { key: "IA", text: "IA", value: "IA" },
                                                        { key: "KS", text: "KS", value: "KS" },
                                                        { key: "KY", text: "KY", value: "KY" },
                                                        { key: "LA", text: "LA", value: "LA" },
                                                        { key: "ME", text: "ME", value: "ME" },
                                                        { key: "MD", text: "MD", value: "MD" },
                                                        { key: "MA", text: "MA", value: "MA" },
                                                        { key: "MI", text: "MI", value: "MI" },
                                                        { key: "MN", text: "MN", value: "MN" },
                                                        { key: "MS", text: "MS", value: "MS" },
                                                        { key: "MO", text: "MO", value: "MO" },
                                                        { key: "MT", text: "MT", value: "MT" },
                                                        { key: "NE", text: "NE", value: "NE" },
                                                        { key: "NV", text: "NV", value: "NV" },
                                                        { key: "NH", text: "NH", value: "NH" },
                                                        { key: "NJ", text: "NJ", value: "NJ" },
                                                        { key: "NM", text: "NM", value: "NM" },
                                                        { key: "NY", text: "NY", value: "NY" },
                                                        { key: "NC", text: "NC", value: "NC" },
                                                        { key: "ND", text: "ND", value: "ND" },
                                                        { key: "OH", text: "OH", value: "OH" },
                                                        { key: "OK", text: "OK", value: "OK" },
                                                        { key: "OR", text: "OR", value: "OR" },
                                                        { key: "PA", text: "PA", value: "PA" },
                                                        { key: "RI", text: "RI", value: "RI" },
                                                        { key: "SC", text: "SC", value: "SC" },
                                                        { key: "SD", text: "SD", value: "SD" },
                                                        { key: "TN", text: "TN", value: "TN" },
                                                        { key: "TX", text: "TX", value: "TX" },
                                                        { key: "UT", text: "UT", value: "UT" },
                                                        { key: "VT", text: "VT", value: "VT" },
                                                        { key: "VA", text: "VA", value: "VA" },
                                                        { key: "WA", text: "WA", value: "WA" },
                                                        { key: "WV", text: "WV", value: "WV" },
                                                        { key: "WI", text: "WI", value: "WI" },
                                                        { key: "WY", text: "WY", value: "WY" },
                                                    ]}
                                                    // tslint:disable-next-line: max-line-length
                                                    onChange={(e, d) => handleNameLocationChange(d.value as string, props.index, i, dispatch, a, 3)} />
                                            <Form.Input size={"small"} type={"text"} value={o.zip} placeholder={"Zip"} fluid
                                                error={o.zip.length > 0 && o.zip.match(/[0-9]{5}/g) == null ? "Zip Code must be 5 digits" : undefined}
                                            // tslint:disable-next-line: max-line-length
                                                onChange={(e) => handleNameLocationChange(e.target.value, props.index, i, dispatch, a, 4)} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Table.Cell>
                        </Table.Row>)
                }
            </EnumeratedTable>
      </div>
    );
  };

export default NamesAndLocationsAnswer;
